import React from 'react';
import clsx from 'clsx';
import { Device } from '@smart-tv/components/player/player-devices/types';
import testIds from '@smart-tv/e2e/shared/variables';

import Button from '@smart-tv/components/button/button';

import PlayerDevicesContext, { MAX_DEVICES_LIMIT } from '../player-devices-context';
import styles from './player-devices-dialog.module.scss';

interface Props {
  setFocus: (focusKey: string) => void;
}

export const PlayerDevicesDialogEditScreenFooter: React.FC<Props> = (props: Props) => {
  const { setFocus } = props;
  const { devices, handleRemoveDevices, handleClose } = React.useContext(PlayerDevicesContext);

  const removableDevices = devices?.filter(({ active }) => !active);

  const handleRemoveAllDevices = React.useCallback(
    (devices?: Device[]) => {
      const uids = devices?.map(({ uid }) => uid);

      uids && handleRemoveDevices(uids);

      setFocus('PlayerDevicesContinue');
    },
    [handleRemoveDevices, setFocus]
  );

  return (
    <div className={styles['player-devices-dialog-edit-screen__footer']}>
      {removableDevices?.length !== 0 && (
        <Button
          onClick={() => handleRemoveAllDevices(removableDevices)}
          className={clsx(
            styles['player-devices-dialog-edit-screen__footer-button'],
            styles['player-devices-dialog-edit-screen__footer-button--remove-all']
          )}
          data-testid={testIds.player.tv2Dialog.removeAllButton}
        >
          Ryd Alt
        </Button>
      )}

      <Button
        onClick={handleClose}
        focusKey={'PlayerDevicesContinue'}
        disabled={devices && devices?.length >= MAX_DEVICES_LIMIT}
        className={styles['player-devices-dialog-edit-screen__footer-button']}
        data-testid={testIds.player.tv2Dialog.continuePlayingButton}
      >
        Fortsæt afspilning
      </Button>
    </div>
  );
};

export default PlayerDevicesDialogEditScreenFooter;
